/* Template Name: Landrick - Saas & Software Landing Page Template
   Author: Shreethemes
   E-mail: support@shreethemes.in
   Created: August 2019
   Version: 4.2.0
   Updated: March 2022
   File Description: Main JS file of the template
*/

/*********************************/
/*         INDEX                 */
/*================================
 *     01.  Loader               *
 *     02.  Toggle Menus         *
 *     03.  Active Menu          *
 *     04.  Clickable Menu       *
 *     05.  Back to top          *
 *     06.  Feather icon         *
 *     06.  DD Menu              *
 *     06.  Active Sidebar Menu  *
 *     07.  Contact us           *
 ================================*/

window.addEventListener("load", fn, false);

//  window.onload = function loader() {
function fn() {
	// Preloader
	if (document.getElementById("preloader")) {
		setTimeout(() => {
			document.getElementById("preloader").style.visibility = "hidden";
			document.getElementById("preloader").style.opacity = "0";
		}, 350);
	}
	// Menus
	activateMenu();
}

//Menu
// Toggle menu
function toggleMenu() {
	document.getElementById("isToggle").classList.toggle("open");
	var isOpen = document.getElementById("navigation");
	if (isOpen.style.display === "block") {
		isOpen.style.display = "none";
	} else {
		isOpen.style.display = "block";
	}
}

//----------------------------------------------------------------
const menuTogglesID = document.querySelectorAll("#isToggle");

if (menuTogglesID.length > 0) {
	menuTogglesID.forEach((menuToggle) => {
		menuToggle.addEventListener("click", function (e) {
			toggleMenu(menuToggle);
		});
	});
}
//----------------------------------------------------------------

//Menu Active
function getClosest(elem, selector) {
	// Element.matches() polyfill
	if (!Element.prototype.matches) {
		Element.prototype.matches =
			Element.prototype.matchesSelector ||
			Element.prototype.mozMatchesSelector ||
			Element.prototype.msMatchesSelector ||
			Element.prototype.oMatchesSelector ||
			Element.prototype.webkitMatchesSelector ||
			function (s) {
				var matches = (this.document || this.ownerDocument).querySelectorAll(s),
					i = matches.length;
				while (--i >= 0 && matches.item(i) !== this) {}
				return i > -1;
			};
	}

	// Get the closest matching element
	for (; elem && elem !== document; elem = elem.parentNode) {
		if (elem.matches(selector)) return elem;
	}
	return null;
}

function activateMenu() {
	var menuItems = document.getElementsByClassName("sub-menu-item");
	if (menuItems) {
		var matchingMenuItem = null;
		for (var idx = 0; idx < menuItems.length; idx++) {
			if (menuItems[idx].href === window.location.href) {
				matchingMenuItem = menuItems[idx];
			}
		}

		if (matchingMenuItem) {
			matchingMenuItem.classList.add("active");
			var immediateParent = getClosest(matchingMenuItem, "li");
			if (immediateParent) {
				immediateParent.classList.add("active");
			}

			var parent = getClosest(matchingMenuItem, ".parent-menu-item");
			if (parent) {
				parent.classList.add("active");
				var parentMenuitem = parent.querySelector(".menu-item");
				if (parentMenuitem) {
					parentMenuitem.classList.add("active");
				}
				var parentOfParent = getClosest(parent, ".parent-parent-menu-item");
				if (parentOfParent) {
					parentOfParent.classList.add("active");
				}
			} else {
				var parentOfParent = getClosest(matchingMenuItem, ".parent-parent-menu-item");
				if (parentOfParent) {
					parentOfParent.classList.add("active");
				}
			}
		}
	}
}

// Clickable Menu
if (document.getElementById("navigation")) {
	var elements = document.getElementById("navigation").getElementsByTagName("a");
	for (var i = 0, len = elements.length; i < len; i++) {
		elements[i].onclick = function (elem) {
			if (elem.target.getAttribute("href") === "javascript:void(0)") {
				var submenu = elem.target.nextElementSibling.nextElementSibling;
				submenu.classList.toggle("open");
			}
		};
	}
}

// Menu sticky
function windowScroll() {
	const navbar = document.getElementById("topnav");
	if (navbar != null) {
		if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
			navbar.classList.add("nav-sticky");
		} else {
			navbar.classList.remove("nav-sticky");
		}
	}
}

window.addEventListener("scroll", (ev) => {
	ev.preventDefault();
	windowScroll();
});

// back-to-top
var mybutton = document.getElementById("back-to-top");
window.onscroll = function () {
	scrollFunction();
};

function scrollFunction() {
	if (mybutton != null) {
		if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
			mybutton.style.display = "block";
		} else {
			mybutton.style.display = "none";
		}
	}
}

function topFunction() {
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
}

//ACtive Sidebar
(function () {
	var current = location.pathname.substring(location.pathname.lastIndexOf("/") + 1);
	if (current === "") return;
	var menuItems = document.querySelectorAll(".sidebar-nav a");
	for (var i = 0, len = menuItems.length; i < len; i++) {
		if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
			menuItems[i].parentElement.className += " active";
		}
	}
})();

//Feather icon
feather.replace();

// dd-menu
var ddmenu = document.getElementsByClassName("dd-menu");
for (var i = 0, len = ddmenu.length; i < len; i++) {
	ddmenu[i].onclick = function (elem) {
		elem.stopPropagation();
	};
}

//Tooltip
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new bootstrap.Tooltip(tooltipTriggerEl);
});

//Popovers
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
	return new bootstrap.Popover(popoverTriggerEl);
});

//small menu
try {
	var spy = new Gumshoe("#navmenu-nav a");
} catch (err) {}
//********************* */
/*     Contact us       */
//********************* */
try {
	// Contact Form
	function validateForm() {
		var name = document.forms["myForm"]["name"].value;
		var email = document.forms["myForm"]["email"].value;
		var subject = document.forms["myForm"]["subject"].value;
		var comments = document.forms["myForm"]["comments"].value;
		document.getElementById("error-msg").style.opacity = 0;
		document.getElementById("error-msg").innerHTML = "";
		if (name == "" || name == null) {
			document.getElementById("error-msg").innerHTML = "<div class='alert alert-warning error_message'>*Please enter a Name*</div>";
			fadeIn();
			return false;
		}
		if (email == "" || email == null) {
			document.getElementById("error-msg").innerHTML = "<div class='alert alert-warning error_message'>*Please enter a Email*</div>";
			fadeIn();
			return false;
		}
		if (subject == "" || subject == null) {
			document.getElementById("error-msg").innerHTML = "<div class='alert alert-warning error_message'>*Please enter a Subject*</div>";
			fadeIn();
			return false;
		}
		if (comments == "" || comments == null) {
			document.getElementById("error-msg").innerHTML = "<div class='alert alert-warning error_message'>*Please enter a Comments*</div>";
			fadeIn();
			return false;
		}
		var xhttp = new XMLHttpRequest();
		xhttp.onreadystatechange = function () {
			if (this.readyState == 4 && this.status == 200) {
				document.getElementById("simple-msg").innerHTML = this.responseText;
				document.forms["myForm"]["name"].value = "";
				document.forms["myForm"]["email"].value = "";
				document.forms["myForm"]["subject"].value = "";
				document.forms["myForm"]["comments"].value = "";
			}
		};
		xhttp.open("POST", "php/contact.php", true);
		xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		xhttp.send("name=" + name + "&email=" + email + "&subject=" + subject + "&comments=" + comments);
		return false;
	}

	function fadeIn() {
		var fade = document.getElementById("error-msg");
		var opacity = 0;
		var intervalID = setInterval(function () {
			if (opacity < 1) {
				opacity = opacity + 0.5;
				fade.style.opacity = opacity;
			} else {
				clearInterval(intervalID);
			}
		}, 200);
	}
} catch (err) {}

function previewFile() {
	let preview = document.querySelector(".preview");
	let files = document.querySelector("input[type=file]").files;
	let file = document.querySelector("input[type=file]").files[0];
	let reader = new FileReader();
	reader.onloadend = function () {
		preview.src = reader.result;
	};
	preview.srcset = "";
	if (file) {
		reader.readAsDataURL(file);
	} else {
		preview.src = "";
	}
}
let set_file_avatar = document.getElementById("avatar");
if (set_file_avatar) {
	set_file_avatar.addEventListener("change", function (e) {
		previewFile();
	});
}

function previewRemove() {
	let preview = document.querySelector(".preview");
	let input = document.querySelector('input[name="avatar"]');
	let avatar_id = document.querySelector('input[name="avatar_id"]');
	preview.src = "";
	avatar_id.value = null;
	input = null;
}
let remove_file_avatar = document.getElementById("remove_file_avatar");
if (remove_file_avatar) {
	remove_file_avatar.addEventListener("click", function (e) {
		previewRemove();
	});
}

if (window.history.replaceState) {
	window.history.replaceState(null, null, window.location.href);
}

import tinymce from "tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/plugins/advlist";
import "tinymce/plugins/code";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/table";
import "tinymce/models/dom/model";

document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelector("textarea")) {
		tinymce.init({
			selector: "textarea:not(.no-tiny)",
		});
	}
});

function hideSelectOptionsByParent(parent_select, children_select) {
	if (parent_select && children_select) {
		let parent_value = parent_select.value;
		if (parent_value) {
			let all_aptions = children_select.querySelectorAll("option");
			all_aptions.forEach((option) => {
				option.style.display = "none";
			});
			let active_options = children_select.querySelectorAll('option[data-parent="' + parent_value + '"]');
			let i = 0;
			active_options.forEach((option) => {
				if (i++ == 0) {
					children_select.value = option.value;
				}
				option.style.display = "block";
			});
		}
	}
}

function pairsSelectOptionsByParent(pairs) {
	let forms = document.querySelectorAll("form");
	if (forms) {
		forms.forEach((form) => {
			pairs.forEach((pair) => {
				let parent_select = form.querySelector('select[name="' + pair.parent + '"]'),
					children_select = form.querySelector('select[name="' + pair.child + '"]');
				if (parent_select) {
					parent_select.addEventListener("change", (e) => {
						hideSelectOptionsByParent(parent_select, children_select);
					});
					hideSelectOptionsByParent(parent_select, children_select);
				}
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	let pairs = [{ parent: "country", child: "city" }];
	pairsSelectOptionsByParent(pairs);
});

//===================== FILTER-FORM =====================//
document.addEventListener("DOMContentLoaded", function () {
	const filterForm = document.querySelector(".filter-form");
	if (filterForm) {
		const filterForm_checkboxes = filterForm.querySelectorAll(".form-check");
		const filterForm_selects = filterForm.querySelectorAll(".form-select");
		const filterForm_both = [...filterForm_checkboxes, ...filterForm_selects];

		filterForm_both.forEach((element) => {
			element.addEventListener("change", function () {
				formSubmitAction(filterForm, element);
			});
		});

		async function formSubmitAction(form) {
			const formAction = form.getAttribute("action") ? form.getAttribute("action").trim() : "#";
			const formMethod = form.getAttribute("method") ? form.getAttribute("method").trim() : "GET";
			const formData = new FormData(form);

			form.classList.add("_sending");
			formData.append("action", "filter_vacancies");
			formData.append("wp_query", window.api_settings.wp_query);

			var xhr = new XMLHttpRequest();

			//const urlParams = new URLSearchParams(window.location.search);
			
			const urlParams = new URLSearchParams();
			formData.forEach((value, key) => {
				if (key !== "wp_query") {
					if (value != '' && value != 'null') {
						urlParams.set(key, value);
					}
				}
			});
			let pathArray = window.location.pathname.split("/");
			window.history.replaceState(null, "", "/" + pathArray[1] + "/?" + urlParams);

			document.getElementById("loader").classList.remove("d-none");
			document.querySelectorAll("#posts-block > *:not(#loader)").forEach((element) => {
				element.classList.add("d-none");
			});
			xhr.open("GET", window.location.href);
			// xhr.open("POST", api_settings.ajax_url);
			xhr.send(formData);
			xhr.onload = function () {
				// form.classList.remove("_sending");
				//document.innerHTML = this.responseText;
				let parser = new DOMParser();
				let htmlDoc = parser.parseFromString(this.responseText, "text/html");
				document.getElementById("posts-block").innerHTML = htmlDoc.getElementById("posts-block").innerHTML;
				//formSent(form, this.responseText);
			};
			// const response = await fetch(formAction, {
			// 	method: formMethod,
			// 	body: formData,
			// });
			// if (response.ok) {
			// 	let responseResult = await response.json();
			// 	form.classList.remove("_sending");
			// 	formSent(form, responseResult);
			// } else {
			// 	alert("Error");
			// 	form.classList.remove("_sending");
			// }
		}
		// Actions after submitting the form
		function formSent(form, responseResult = ``) {
			// Create a form submit event
			document.dispatchEvent(
				new CustomEvent("formSent", {
					detail: {
						form: form,
					},
				})
			);
			// Log to the console
			console.log(responseResult);
		}
	}
});

import "./script.js";
